<!--批量  -->
<template>
	<div class="dialogBox">
		<el-dialog v-if="dialogVisible" title="批量调整店铺回单" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="400px" :before-close="cancle">
			<div class="ml15">
				<el-form label-position="top" size="small"  :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px">
					<el-form-item label="请选择是否有回单(Y有/N无):" class="mt15"  prop="voucherFlag">
						<el-select v-model="ruleForm.voucherFlag" class="" size="small" placeholder="选择">
							<el-option label="Y" value="Y">
							</el-option>
							<el-option label="N" value="N">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer mt10">
				<el-button  size="small" @click="cancle()">取 消</el-button>
				<el-button  size="small" type="primary" @click="setBatchUpdate()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			selectAttribute: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				dialogVisible: false,
				ruleForm: {
					voucherFlag:""
				},
				rules:{
					voucherFlag: [{
						required: true,
						message: '请选择是否批量店铺回单',
						trigger: 'change'
					}, ],
				},
				rows: [],
			}
		},
		created() {

		},
		methods: {
			init(rows) {
				this.dialogVisible = true
				this.$nextTick(() => {
					this.ruleForm.voucherFlag = ""
					this.rows = rows
				
				})
			},
		
			// 批量修改
			setBatchUpdate() {
				let that = this;
				that.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						let orderIds = []
						that.rows.forEach(item => {
							orderIds.push(item.dataKey)
						});
						that.$request.post(
								"batchOrder",
								true, {
									orderIds: orderIds,
									voucherFlag: that.ruleForm.voucherFlag,
								}
							)
							.then((res) => {
								if (res.code==0) {
									that.dialogVisible = false
									that.$message.success("批量修改成功！");
									that.$refs['ruleForm'].resetFields();
									that.$emit("getList")
								}
							})
							} else {
								return false;
							}
						})
			},
			
			// 取消
			cancle() {
				this.dialogVisible = false;
				this.$refs['ruleForm'].resetFields();
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 0px 10px;
		}
	}

</style>
